import { render } from "./advantages.vue?vue&type=template&id=1214a255"
import script from "./advantages.vue?vue&type=script&lang=js"
export * from "./advantages.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__